<template>

    <div class="sim">
	<div class="sim-ct">
		<ul>
			<li>
				<h5>Assembling</h5>
				<p>15 Products</p>
			</li>
			<li>
				<h5>Assembling</h5>
				<p>15 Products</p>
			</li>
			<li>
				<h5>Assembling</h5>
				<p>15 Products</p>
			</li>
		</ul>
	</div>
  </div>
</template>
<script>
import index from "@/assets/bar/index.png";
import index_action from "@/assets/bar/index_action.png";
import serve from "@/assets/bar/serve.png";
import serve_action from "@/assets/bar/serve_action.png";
import user from "@/assets/bar/user.png";
import user_action from "@/assets/bar/user_action.png";
import notice from "@/assets/bar/notice.png";
import notice_action from "@/assets/bar/notice_action.png";
import act from "@/assets/bar/act.png";
import act_action from "@/assets/bar/act_action.png";


export default {
  data() {
    return {
      barBtn: 0,
      barList: [
        {
          name: "首页",
          path: "/index/home",
          icon: index,
          icon_action: index_action,
        },
        {
          name: "服务",
          path: "/serve",
          icon: serve,
          icon_action: serve_action,
        }, {
          name: "政策公告",
          path: "/news",
          icon: notice,
          icon_action: notice_action,
        }, {
          name: "技能培训",
          path: "/act",
          icon: act,
          icon_action: act_action,
        },
        {
          name: "我的",
          path: "/user",
          icon: user,
          icon_action: user_action,
        },
      ],
    };
  },
  methods: {
    getBarBtn(index) {
      this.barBtn = index;
    },
  },
};
</script>

<style lang='scss' scoped>
.sim{
	background: #F9F9F9;
	height: 85px;
	padding-top: 40px;
	.sim-ct{
		width: 1200px;
		margin: 0 auto;
		
		
		ul{
			display: flex;
			justify-content: space-between;
			
		}
	}
}
</style>